import { is_empty } from "features/Common/utils/common.utils";
import {
  FIRST_ITEM_INDEX,
  MANAGE_RECORDING_TOOLTIP_WEIGHTS,
  NONE_OPTION_SECTION_VALUE,
} from "../constants/ManageRecordings.constant";
import styles from "../ManageRecordings.module.css";

/**
 * Filters out section mapping records where user selected the "-" (NONE) option.
 * @param {Object} recordToSections
 * @returns {Object} Cleaned mapping object
 */
export const getUpdatedRecordingToSections = (recordToSections = {}) => {
  const newRecordToSection = {};
  Object.keys(recordToSections).forEach((key) => {
    if (recordToSections[key]?.section?.value !== NONE_OPTION_SECTION_VALUE) {
      newRecordToSection[key] = recordToSections[key];
    }
  });
  return newRecordToSection;
};

/**
 * Returns tooltip wrapper class name for the first record item if Onboarding active.
 * @param {Object} record
 * @param {string} currentActive
 * @returns {string|undefined}
 */
export const getSingleRecordClassName = (record, currentActive) => {
  const activeTooltipWeights = [
    MANAGE_RECORDING_TOOLTIP_WEIGHTS.recording_name,
    MANAGE_RECORDING_TOOLTIP_WEIGHTS.section_name,
    MANAGE_RECORDING_TOOLTIP_WEIGHTS.create_section,
    MANAGE_RECORDING_TOOLTIP_WEIGHTS.batch_name,
    MANAGE_RECORDING_TOOLTIP_WEIGHTS.customer_name,
  ];

  if (
    record?.id === FIRST_ITEM_INDEX &&
    activeTooltipWeights.includes(currentActive)
  ) {
    return styles.tooltip_wrapper;
  }
};

/**
 * Extracts expiry date from explicit record.expiry field.
 * @param {Object} record
 * @returns {{ expiryDate: Date | null, isExpired: boolean }}
 */
export const getDownloadTokenExpiry = (record = {}) => {
  const rawExpiry = record?.expiry;
  if (!rawExpiry) {
    return { expiryDate: null, isExpired: false };
  }

  const parsedDate = new Date(rawExpiry);
  if (isNaN(parsedDate.getTime())) {
    return { expiryDate: null, isExpired: false };
  }

  return {
    expiryDate: parsedDate,
    isExpired: Date.now() > parsedDate.getTime(),
  };
};

/**
 * Formats recording file size in MB.
 * @param {Object} record
 * @returns {string} Formatted size string (e.g. "1.92 MB" or "-")
 */
export const formatRecordingFileSize = (record = {}) => {
  const fileSize = record?.file_size ?? record?.size;
  if (is_empty(fileSize)) {
    return "-";
  }
  return `${fileSize} MB`;
};
